// src/components/Navbar/Navbar.js
import React, { useState } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="main-navbar">
      <div className="navbar-container">
        <button className="mobile-menu-btn" onClick={toggleMenu}>
          {isMenuOpen ? '✕' : '☰'} Menu
        </button>

        <ul className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
          <li><Link to="/#home">Home</Link></li>
          
          <li className="dropdown">
            <Link to="#">About Us <span className="caret">▼</span></Link>
            <ul className="dropdown-menu">
              <li><Link to="/#vision-mission">Vision & Mission</Link></li>
              <li><Link to="/#about">About College</Link></li>
              <li><Link to="/par-profile">PAR Profile</Link></li>
              <li><Link to="/student-details">Student Details</Link></li>
            </ul>
          </li>

          <li className="dropdown">
            <Link to="#">College Staff <span className="caret">▼</span></Link>
            <ul className="dropdown-menu">
              <li><Link to="/teaching-staff">Teaching Staff</Link></li>
              <li><Link to="/staff-achievements">Staff Achievements</Link></li>
            </ul>
          </li>

          <li className="dropdown">
            <Link to="#">Courses <span className="caret">▼</span></Link>
            <ul className="dropdown-menu">
              <li><Link to="/bed">B.Ed (Bachelor of Education)</Link></li>
              <li><Link to="/dsm">D.S.M (Diploma in School Management)</Link></li>
              <li><Link to="/ma-education">M.A. in Education</Link></li>
            </ul>
          </li>

          <li className="dropdown">
            <Link to="#">Library <span className="caret">▼</span></Link>
            <ul className="dropdown-menu">
              <li><Link to="/library">Library Information</Link></li>
              <li><Link to="/library-at-a-glance">Library at a Glance</Link></li>
              <li><Link to="/mission-of-library">Mission of Library</Link></li>
            </ul>
          </li>

          <li className="dropdown">
            <Link to="#">IQAC <span className="caret">▼</span></Link>
            <ul className="dropdown-menu">
              <li><Link to="/iqac-objectives">IQAC Objectives</Link></li>
              <li><Link to="/iqac-members">IQAC Members</Link></li>
              <li><Link to="/iqac-activities">IQAC Activities & Reports</Link></li>
            </ul>
          </li>

          <li className="dropdown">
            <Link to="#">NAAC <span className="caret">▼</span></Link>
            <ul className="dropdown-menu">
              <li><Link to="/naac-peer-team-visit">Peer Team Visit</Link></li>
              <li><Link to="/naac-ssr">SSR</Link></li>
              <li><Link to="/naac-audit-report">Audit Report</Link></li>
              <li><Link to="/naac-aishe-report">AISHE Report</Link></li>
              <li><Link to="/naac-university-affiliation">University Affiliation</Link></li>
              <li><Link to="/naac-certificate">Naac Certificate</Link></li>
            </ul>
          </li>

          <li className="dropdown">
            <Link to="#">Placement <span className="caret">▼</span></Link>
            <ul className="dropdown-menu">
              <li><Link to="/placement-cell">Placement Cell</Link></li>
              <li><Link to="/placement-records">Placement Record</Link></li>
              <li><Link to="/internship-opportunities">Internship Opportunities</Link></li>
            </ul>
          </li>

          <li className="dropdown">
            <Link to="#">Alumni <span className="caret">▼</span></Link>
            <ul className="dropdown-menu">
              <li><Link to="/alumni-association">Alumni Association</Link></li>
              <li><Link to="/alumni-registration">Alumni Registration</Link></li>
            </ul>
          </li>

          <li className="dropdown">
            <Link to="/gallery">Gallery <span className="caret">▼</span></Link>
            <ul className="dropdown-menu">
              <li><Link to="/college-events">College Events</Link></li>
              <li><Link to="/campus-life">Campus Life</Link></li>
              <li><Link to="/blood-donation-camp">Blood Donation Camp</Link></li>
              <li><Link to="/cultural-gallery">Culture</Link></li>
              <li><Link to="/infrastructure-gallery">Infrastructure</Link></li>
              <li><Link to="/naac-peer-team-visit">NAAC Visit</Link></li>
              <li><Link to="/social-activity">Social Activity</Link></li>
              <li><Link to="/sports-gallery">Sports</Link></li>
            </ul>
          </li>

          <li className="dropdown">
            <Link to="#">Infrastructure <span className="caret">▲</span></Link>
            <ul className="dropdown-menu">
              <li><Link to="/infrastructure-land-details">Land Details</Link></li>
              <li><Link to="/infrastructure-building-map">Building Map</Link></li>
              <li><Link to="/infrastructure-completion-certificate">Completion Certificate</Link></li>
              <li><Link to="/infrastructure-ramp">RAMP</Link></li>
              <li><Link to="/infrastructure-land-title">Land Title Certificate</Link></li>
              <li><Link to="/infrastructure-land-use">Land Use Certificate</Link></li>
              <li><Link to="/infrastructure-fire-safety">Fire Safety</Link></li>
              <li><Link to="/infrastructure-na">NA</Link></li>
              <li><Link to="/infrastructure-non-imbalance">Non-Imbalance</Link></li>
              <li><Link to="/infrastructure-kharedi-khat">Kharidi-Khat</Link></li>
            </ul>
          </li>

          <li><Link to="/contact">Contact Us</Link></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
